export default __webpack_public_path__ + "static/media/elder-tree.cb785e16.png";